import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=34242cc2&scoped=true"
import script from "./policyDetail.vue?vue&type=script&lang=js"
export * from "./policyDetail.vue?vue&type=script&lang=js"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=34242cc2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34242cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34242cc2')) {
      api.createRecord('34242cc2', component.options)
    } else {
      api.reload('34242cc2', component.options)
    }
    module.hot.accept("./policyDetail.vue?vue&type=template&id=34242cc2&scoped=true", function () {
      api.rerender('34242cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/policyDetail.vue"
export default component.exports